// «Ещё» на телефоне: остальные разделы списком.
import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { MENU } from '../shell/nav';
import { PageHead } from './common';

const IN_TABBAR = new Set(['/', '/decisions', '/creatives']);

export function MorePage() {
  return (
    <>
      <PageHead title="Ещё" />
      <div className="pc">
        <nav className="card" aria-label="Остальные разделы" style={{ padding: '4px 16px' }}>
          {MENU.filter((s) => !IN_TABBAR.has(s.to)).map((s, i) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.to}
                to={s.to}
                className="flex items-center gap-3"
                style={{
                  height: 56,
                  color: 'var(--text)',
                  fontWeight: 500,
                  fontSize: 'var(--fs-md)',
                  borderTop: i ? '1px solid var(--border)' : undefined,
                }}
              >
                <Icon size={20} className="muted" />
                <span className="flex-1">{s.label}</span>
                <ChevronRight size={18} className="muted" />
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
}
